import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Props = {
  children: React.ReactNode;
  color:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'destructive'
    | 'info';
  msg: string;
  isHtml?: boolean;
};
const ArrowTooltip = ({ children, msg, color, isHtml = false }: Props) => {
  return (
    <div className="flkex justify-center">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{children}</TooltipTrigger>
          <TooltipContent color={color}>
            {isHtml ? (
              <div dangerouslySetInnerHTML={{ __html: msg }} />
            ) : (
              <p>{msg}</p>
            )}
            <TooltipArrow className="fill-primary" />
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ArrowTooltip;
